module.exports = __webpack_public_path__ + "img/icon-back.0865a0fe.svg";